import { Component, OnInit, Input, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';
import { Payment } from '../../../shared/sdk';
import { Observable } from 'rxjs';
import { PaymentService } from '../../../payments/payment.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-document-payment-new',
  templateUrl: './document-payment-new.component.html',
  styleUrls: ['./document-payment-new.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocumentPaymentNewComponent implements OnInit {
  @Input() currencyId: string;
  @Input() locale: string;
  @Input() last: boolean;
  @Input() payment: Payment;
  @Input() showDate = false;
  @Output() delete = new EventEmitter<Payment>();
  @Output() edit = new EventEmitter<Payment>();

  expanded = false;

  constructor(
    private translateService: TranslateService,
    private paymentService: PaymentService,
  ) { }

  ngOnInit() {
  }

  get note(): string {
    return this.payment.note;
  }

  onDelete(): void {
    this.delete.emit(this.payment);
  }

  onEdit(): void {
    this.edit.emit(this.payment);
  }

  get type(): Observable<string> {
    return this.translateService.get(this.paymentService.paymentTypes.find(pt => pt.value === this.payment.type).name);
  }

}
